import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  Category,
  CategoryNotificationEnvelope,
  DeleteCategoryOptions,
  DeleteCategoryResponse,
  ListCategoriesOptions,
  ListCategoryResponse,
  UpdateCategory,
  UpdateCategoryApplicationErrors,
  UpdateCategoryResponse,
  createCategory as universalCreateCategory,
  deleteCategory as universalDeleteCategory,
  listCategories as universalListCategories,
  updateCategory as universalUpdateCategory,
} from './bookings-v1-category-categories.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/bookings' };

export function listCategories(
  httpClient: HttpClient
): ListCategoriesSignature {
  return (options?: ListCategoriesOptions) =>
    universalListCategories(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListCategoriesSignature {
  /**
   * Retrieves all categories.
   * @param - Options to use when listing categories.
   * @deprecated
   */
  (options?: ListCategoriesOptions): Promise<
    NonNullablePaths<
      ListCategoryResponse,
      `categories` | `categories.${number}.status`,
      4
    >
  >;
}

export function createCategory(
  httpClient: HttpClient
): CreateCategorySignature {
  return (category: NonNullablePaths<Category, `name`, 2>) =>
    universalCreateCategory(
      category,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateCategorySignature {
  /**
   * Creates a category.
   * @param - Category to create.
   * @returns Created category.
   * @deprecated
   */
  (category: NonNullablePaths<Category, `name`, 2>): Promise<
    NonNullablePaths<Category, `status`, 2>
  >;
}

export function updateCategory(
  httpClient: HttpClient
): UpdateCategorySignature {
  return (_id: string, category: NonNullablePaths<UpdateCategory, `name`, 2>) =>
    universalUpdateCategory(
      _id,
      category,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateCategorySignature {
  /**
   * Updates a category.
   *
   *
   * Each time the category is updated, revision increments by 1. You must include
   * the number of the existing revision when updating the category. This ensures
   * you're working with the latest service information and prevents unintended
   * overwrites.
   * @param - Category ID.
   * @deprecated
   */
  (_id: string, category: NonNullablePaths<UpdateCategory, `name`, 2>): Promise<
    NonNullablePaths<UpdateCategoryResponse, `category.status`, 3> & {
      __applicationErrorsType?: UpdateCategoryApplicationErrors;
    }
  >;
}

export function deleteCategory(
  httpClient: HttpClient
): DeleteCategorySignature {
  return (_id: string, options?: DeleteCategoryOptions) =>
    universalDeleteCategory(
      _id,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface DeleteCategorySignature {
  /**
   * Deletes a category.
   *
   *
   * You can specify `{"deleteServices": true}` to also delete all associated
   * services. Learn more about [deleting a service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service).
   * @param - ID of the category to delete.
   * @deprecated
   */
  (
    _id: string,
    options?: DeleteCategoryOptions
  ): Promise<DeleteCategoryResponse>;
}

export const onCategoryNotification = EventDefinition(
  'com.wixpress.bookings.services.api.v1.CategoryNotification',
  false,
  (event: CategoryNotificationEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(event)
)<CategoryNotificationEnvelope>();

export {
  AccountInfo,
  BaseEventMetadata,
  BatchCreateCategoryRequest,
  BatchCreateCategoryResponse,
  BatchDeleteCategoryRequest,
  BatchDeleteCategoryResponse,
  BatchUpdateCategoryRequest,
  BatchUpdateCategoryResponse,
  Category,
  CategoryNotification,
  CategoryNotificationEnvelope,
  CreateCategoryRequest,
  CreateCategoryResponse,
  DeleteCategoryOptions,
  DeleteCategoryRequest,
  DeleteCategoryResponse,
  Event,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListCategoriesOptions,
  ListCategoryRequest,
  ListCategoryResponse,
  MessageEnvelope,
  Status,
  UpdateCategory,
  UpdateCategoryRequest,
  UpdateCategoryResponse,
  WebhookIdentityType,
} from './bookings-v1-category-categories.universal.js';
